import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';
import Loader from '../../components/Loader/Loader';
import dots from '../../assets/dots.svg';
import { iconBucket } from '../../utils/icons';
import formatDate from '../../utils/formatDate';
import fixDateTimezone from '../../utils/fixDateTimezone';
import getVinBlacklist from '../../api/vinBlacklist/getVinBlacklist';
import deleteVinFromBlacklist from '../../api/vinBlacklist/deleteVinFromBlacklist';
import AddVinModal from './AddVinModal';
import useServerTable from './useServerTable';

const tableStyle = { backgroundColor: 'white' };

// ÐÐ°ÑÐ¸Ð½Ñ Ð¸Ð· Ð±Ð°Ð·Ñ Ñ ÑÑÐ¸Ð¼ VIN: Ð½Ð° Ð½Ð¸Ñ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼.
const CarsCell = ({ cars }) =>
  cars.length === 0
    ? 'â'
    : cars.map((car) => (
        <div key={car.carId}>
          <Link to={`/cars/car/${car.carId}/main-data`}>
            {[car.mark, car.model].filter(Boolean).join(' ') || `ID ${car.carId}`}
          </Link>
          {car.stock > 0 ? `, Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸: ${car.stock}` : ''}
        </div>
      ));

const VinBlacklist = () => {
  const [reload, setReload] = useState(0);
  const [addOpen, setAddOpen] = useState(false);
  // ÐÑÐ²ÐµÑ Ð±ÑÐºÐ° Ð¾ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸: Ð² ÐºÐ¾Ð½ÑÑÑÐµ-ÐºÐ¾Ð¿Ð¸Ð¸ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÑÐµÐ½Ð¸Ñ, Ð¾Ð½ Ð²ÐµÐ´ÑÑÑÑ Ð² Ð³Ð»Ð°Ð²Ð½Ð¾Ð¼ ÐºÐ¾Ð½ÑÑÑÐµ
  const [sync, setSync] = useState(null);
  const replica = !!sync?.replica;

  const columns = useMemo(
    () => [
      { Header: 'VIN', accessor: 'vin', width: '25%' },
      { Header: 'ÐÑÐ¸ÑÐ¸Ð½Ð°', accessor: (row) => row.reason || 'â', width: '25%' },
      {
        Header: 'ÐÐ¾Ð±Ð°Ð²Ð»ÐµÐ½',
        accessor: (row) => (row.createdAt ? formatDate(fixDateTimezone(row.createdAt), true) : ''),
        width: '20%',
      },
      {
        Header: 'Ð Ð±Ð°Ð·Ðµ',
        accessor: 'cars',
        Cell: ({ value: cars }) => <CarsCell cars={cars || []} />,
        disableSortBy: true,
      },
      { Header: <img src={dots} alt="Dots" />, accessor: 'dots' },
    ],
    []
  );

  const { table, tableProps, loaded, loading, searching, value, setValue, search, setPagination } = useServerTable({
    fetcher: getVinBlacklist,
    key: 'vins',
    columns,
    reload,
    onData: (data) => setSync(data?.sync || null),
  });

  const popover = useMemo(
    () => [
      {
        title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ',
        icon: iconBucket(),
        onClick: (row) =>
          deleteVinFromBlacklist(row?.id)
            .then(() => setReload((n) => n + 1))
            .catch(() => {}),
      },
    ],
    []
  );

  return (
    <>
      <TableTabs
        setFilter={search}
        value={value}
        setValue={setValue}
        navigate={() => setAddOpen(true)}
        button="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ"
        inputPlaceholder="ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ VIN"
        advancedSearch={false}
        // ÐÐ¾Ð¿Ð¸Ñ ÑÑÐ¶Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°: ÐºÐ½Ð¾Ð¿ÐºÐ¸ Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑÂ» Ð½ÐµÑ
        addButton={!replica}
      />
      {replica && (
        <p style={{ margin: '10px 0 0', fontSize: 14, color: '#8b8b8b' }}>
          Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð²ÐµÐ´ÑÑÑÑ Ð² Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¼ ÐºÐ¾Ð½ÑÑÑÐµ.{' '}
          {sync.lastSyncAt ? `ÐÐ±Ð½Ð¾Ð²Ð»ÑÐ½: ${formatDate(fixDateTimezone(sync.lastSyncAt), true)}.` : 'ÐÑÑ Ð½Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐ»ÑÑ.'}
          {sync.error ? ` ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ: ${sync.error}.` : ''}
        </p>
      )}
      <br />
      {!loaded ? (
        <Loader />
      ) : !table.page.length && !loading ? (
        <Empty title={searching ? 'ÐÐ¾ ÑÑÐ¾Ð¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾.' : 'Ð ÑÑÑÐ½Ð¾Ð¼ ÑÐ¿Ð¸ÑÐºÐµ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ VIN.'} />
      ) : (
        <Table
          {...tableProps}
          all={'VIN'}
          style={tableStyle}
          api={'/api/crm/vin-blacklist'}
          response={'vins'}
          popover={replica ? undefined : popover}
          edit={!replica}
        />
      )}
      <AddVinModal
        isOpen={addOpen}
        onClose={() => setAddOpen(false)}
        onDone={() => {
          setAddOpen(false);
          setPagination((prev) => ({ ...prev, page: 1 }));
          setReload((n) => n + 1);
        }}
      />
    </>
  );
};

export default VinBlacklist;
